import React, { Component } from 'react';


class CategoryCheckBox extends Component {
  constructor(...args) {
    super(...args)
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = function() {
    var handleToggle = this.props.handleToggle;
    handleToggle(this.props.id)
  }

  render () {
    return (
      <div key={this.props.id} className="checkbox-wrapper">
        <input
          id={this.props.id}
          type="checkbox"
          checked={this.props.isActive}
          />
        <label className="filter-category" htmlFor={this.props.id} onClick={this.handleChange}>
          {this.props.title}
        </label>
      </div>
    )
  }
}

export default CategoryCheckBox;



// WEBPACK FOOTER //
// ./src/Components/CategoryCheckBox.js